import React from "react";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Icon from "@amzn/meridian/icon";
import alertFilledTokens from "@amzn/meridian-tokens/base/icon/alert-filled";
import { useAppSelector } from "src/store/store";
import { Field } from "src/store/modelManagementSlice";
import "src/components/shared/recordLine/recordLine.scss";

interface ModelFieldListProps {
  record: Field;
  hasError?: boolean;
  onClick: () => void;
}

const ModelFieldList: React.FC<ModelFieldListProps> = ({ record, hasError, onClick }) => {
  const { selectedFieldId } = useAppSelector((state) => state.modelSlice);

  const selected = record.id === selectedFieldId;

  const getDescription = (record: Field) => {
    return record.description;
  };

  return (
    <div key={record.id} className="row-style" onClick={onClick}>
      <Row className={selected ? "selected-color" : "unselected-color"} spacing={"300"}>
        {selected ? <div className="pre-line"></div> : <></>}
        <Column spacing={"100"} spacingInset={"200"}>
          <Row spacing="100" alignmentVertical="center">
            <Text type={selected ? "h50" : "b200"}>{record.name}</Text>
            {hasError && <Icon tokens={alertFilledTokens} color="error" />}
          </Row>
          <Text type="b200" color="secondary" truncate>
            {getDescription(record)}
          </Text>
        </Column>
      </Row>
    </div>
  );
};

export default ModelFieldList;
